import Canvas from './Canvas';
import React from 'react';
import { canvasPixelToNorm } from '../../Utils/PixelUtils'
import { normalizeWheel } from '../../Utils/ScrollUtils';
class InputCanvas extends React.Component {

    constructor(props) {
        super(props);

        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseUp = this.handleMouseUp.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.handleMouseEnter = this.handleMouseEnter.bind(this);

        this.handleTouchStart = this.handleTouchStart.bind(this);
        this.handleTouchEnd = this.handleTouchEnd.bind(this);
        this.handleTouchMove = this.handleTouchMove.bind(this);

        this.handleScroll = this.handleScroll.bind(this);

        this.state = {
            isDrawing: false
        }
    }

    isLeftMouseButtonPressed(e) {
        return e.buttons === undefined
            ? e.which === 1
            : (e.buttons & 1) === 1;
    }

    getRelativePosition(e) {
        var rect = e.target.getBoundingClientRect();
        return canvasPixelToNorm(e.clientX - rect.left, e.clientY - rect.top, this.props.width);
    }

    getRelativeTouchPosition(e) {
        var rect = e.target.getBoundingClientRect();
        return canvasPixelToNorm(e.touches[0].clientX - rect.left, e.touches[0].clientY - rect.top, this.props.width);
    }

    handleMouseDown(e) {
        if (!this.isLeftMouseButtonPressed(e)) {
            return
        }

        const { x, y } = this.getRelativePosition(e);

        this.props.onInputStart(x, y);
        this.setState({
            isDrawing: true
        })
    }

    handleMouseLeave(e) {
        if (this.state.isDrawing) {
            const { x, y } = this.getRelativePosition(e);
            this.props.onInputEnd(x, y);
            this.setState({
                isDrawing: false
            })
        }
        this.props.onHoverEnd();
    }

    handleMouseUp(e) {
        if (this.isLeftMouseButtonPressed(e)) {
            return
        }
        if (this.state.isDrawing) {
            const { x, y } = this.getRelativePosition(e);
            this.props.onInputEnd(x, y);
            this.setState({
                isDrawing: false
            })
        }
    }

    handleMouseMove(e) {
        const { x, y } = this.getRelativePosition(e);

        if (!this.state.isDrawing && this.isLeftMouseButtonPressed(e)) {
            this.props.onInputStart(x, y);
            return;
        } else if (!this.state.isDrawing) {
            this.props.onHoverStart(x, y);
            return;
        }

        this.props.onInputMove(x, y);
    }

    handleMouseEnter(e) {
        const { x, y } = this.getRelativePosition(e);

        if (this.isLeftMouseButtonPressed(e)) {
            this.props.onInputStart(x, y);
            this.setState({
                isDrawing: true
            })
        }
    }

    handleTouchMove(e) {
        e.preventDefault();
        e.stopPropagation();
        const { x, y } = this.getRelativeTouchPosition(e);

        if (!this.state.isDrawing) {
            this.props.onInputStart(x, y);
            this.setState({
                isDrawing: true
            })
            return;
        }

        this.props.onInputMove(x, y);
    }

    handleTouchEnd(e) {
        e.preventDefault();
        e.stopPropagation();
        if (this.state.isDrawing) {
            if (e.touches.length) {
                const { x, y } = this.getRelativeTouchPosition(e);
                this.props.onInputEnd(x, y);
            } else {
                this.props.onInputEnd();
            }
            this.setState({
                isDrawing: false
            })
        }
    }

    handleTouchStart(e) {
        e.preventDefault();
        e.stopPropagation();
        const { x, y } = this.getRelativeTouchPosition(e);

        this.props.onInputStart(x, y);
        this.setState({
            isDrawing: true
        })
    }

    handleScroll(e) {
        e.preventDefault();
        e.stopPropagation();
        this.props.onScroll(-normalizeWheel(e).pixelY / 100 / 20)
    }

    render() {
        return (
            <Canvas data={this.props.canvasData} width={this.props.width} border={this.props.border} redraw={this.props.redraw}
                onMouseMove={this.handleMouseMove}
                onMouseDown={this.handleMouseDown}
                onMouseUp={this.handleMouseUp}
                onMouseLeave={this.handleMouseLeave}
                onMouseEnter={this.handleMouseEnter}
                onTouchStart={this.handleTouchStart}
                onTouchEnd={this.handleTouchEnd}
                onTouchMove={this.handleTouchMove} 
                onScroll={this.handleScroll}/>
        );
    }
}

export default InputCanvas;
